<template>
  <div class="inline-block" @click="download">
    <Button v-if="!divInsteadOfButton" :class="classes">
      <slot/>
    </Button>
    <div v-else>
      <slot/>
    </div>
    <div v-if="showStats" class="mb-1">{{ readableFileSize }}</div>
    <loading-panel
        v-if="loading"
        :class="[loadingPanelClasses, 'loading-panel-download']"
        :message="downloadMessage"
        :progress="progress"
        :show-progress-bar="true"
        :time-in-seconds="0"
    />
    <form
        v-if="doFormDownload"
        method="POST"
        :action="fullURL"
        style="display: none;"
        ref="downloadForm"
        enctype="application/x-www-form-urlencoded"
    >
      <input type="hidden" name="authToken" :value="'Bearer ' + this.$store.getters.authToken" />
    </form>
  </div>
</template>

<script>
import {saveAs} from 'file-saver';
import Button from "@/components/forms/Button";
import LoadingPanel from "@/components/LoadingPanel";
import axios from "axios";
import filesize from "file-size";

export default {
  name: "DownloadButton",
  components: {
    Button,
    LoadingPanel
  },
  props: {
    objectId: {type: String, required: true},
    fileKey: {type: String, default: ""},
    showStats: {type: Boolean, default: false},
    classes: {type: String, default: ''},
    username: {type: String, default: ''},
    password: {type: String, default: ''},
    fileKeyOnly: {type: Boolean, default: false},
    divInsteadOfButton: {type: Boolean, default: false},
    downloadMessage: {type: String, default: 'Downloading your file.<br />Please wait.'},
    loadingPanelClasses: {type: String, default: ''},
    externalFileSize: {type: Number, default: null},
    goToDownloadLink: {type: Boolean, default: false},
    doFormDownload: {type: Boolean, default: false},
  },
  data() {
    return {
      fileSize: '',
      readableFileSize: '',
      loading: false,
      progress: 0,
      storageURL: '',
      clientURL: '',
      src: '',
      action: '',
      authToken: '',
      url: '',
      type: '',
    };
  },
  computed: {
    fullURL() {
      return `${this.storageURL}/${this.type.toLowerCase()}s/${this.objectId}/${this.fileKey}/download`;
    }
  },
  watch: {
    fileSize() {
      this.readableFileSize = filesize(this.fileSize * 1000, {fixed: 2, spacer: ' '}).human('si');
    }
  },
  beforeMount() {
    if (this.externalFileSize) {
      this.fileSize = this.externalFileSize;
    } else if (this.showStats) {
      this.getStats();
    }
    this.setUpStorage();
  },
  methods: {
    async setUpStorage() {
      try {
        this.type = await this.$store.dispatch('getItemType', {
          id: this.objectId
        });
      } catch (e) {
        console.error(e);
      }
      return fetch(process.env.VUE_APP_CONFIG)
          .then(r => r.json())
          .then(config => {
            console.log('setup downloadb', config)
            this.storageURL = config.sfx.project.webapp.storageHost + '/api/v2';
            this.clientURL = config.sfx.project.webapp.apiHost + '/api/v2';
          });
    },
    async getStats() {
      return await this.$store.dispatch(`clientGet${this.type}Info`, {id: this.objectId, key: this.fileKey})
          .then(data => {
            this.fileSize = (parseInt(data['content-length']) / 1000);
            return data;
          });
    },
    async download() {
      this.progress = 1;
      let type;
      let config;
      if (!this.username) {
        console.log('no username', this.username);
        this.loading = true;
        type = await this.$store.dispatch('getItemType', {
          id: this.objectId
        });
        config = {
          headers: {'Authorization': 'Bearer ' + this.$store.getters.authToken},
        };
        await this.doTheDownload(config, type);
      } else {
        console.log('with username', this.username, this.storageURL);
        type = 'asset';
        /*
         config = {
            auth: {
             username: this.username,
             password: this.password,
           }
         };*/
        window.open(`${this.storageURL}/${type.toLowerCase()}s/${this.objectId}/${this.fileKey}`);
      }
    },
    async doTheDownload(config, type) {
      let $this = this;
      config.responseType = 'blob';
      config.onDownloadProgress = progressEvent => {
        const total = parseFloat(progressEvent.total);
        const current = progressEvent.loaded;
        $this.progress = Math.floor(current / total * 100)
      }
      this.url = `${this.storageURL}/${type.toLowerCase()}s/${this.objectId}`;
      if (this.fileKey) {
        this.url += '/' + this.fileKey
      }
      if(this.goToDownloadLink) {
        console.log('this.goToDownloadLink', this.goToDownloadLink);
        window.open(this.url, '_blank');
        this.loading = false;
        return;
      }
      if(this.doFormDownload) {
        console.log('DOWNLOAD FORM', this.doFormDownload);
        this.$refs.downloadForm.submit();
        this.loading = false;
        return;
      }
      console.log('ELSE')
      axios.get(this.url, config)
          .then(data => {
            if (!data) {
              return '';
            }
            (async () => {
              $this.loading = false;
              let targetFileKey = $this.fileKey.replace('.link', '');
              saveAs(data.data, $this.fileKeyOnly ? targetFileKey : $this.objectId + '_' + targetFileKey);
            })();
          }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style lang="scss">
.loading-panel-download {
  position: absolute;
  z-index: 55;
}

.not-absolute {
  .loading-panel-download {
    position: static;
  }
}

#frame, #downloadForm {
  visibility: hidden;
  position: absolute;
  top: 0;
  z-index: -1;
}
</style>